/// <amd-module name="Reporting/Visuals/VisualHeader" />
import * as React from "react";
import { css } from "VSSUI/Util";
import { VisualSubtitle } from "./VisualSubtitle";
import { VisualTitle } from "./VisualTitle";

export interface VisualHeaderProps {
    title: string;
    subtitle?: string;
    /** Hides the title and subtitle content */
    hideTitle?: boolean;
    dataQualityWarning?: string;
}

export class VisualHeader extends React.PureComponent<VisualHeaderProps> {
    public render(): JSX.Element {
        return (
            <div className={css("visual-header", this.props.subtitle && "with-subtitle")}>
                <div className={"visual-title-and-subtitle-container text-ellipsis"}>
                    <VisualTitle
                        text={this.props.title}
                        suppressDefaultPadding
                        hideTitle={this.props.hideTitle}
                        dataQualityWarning={this.props.dataQualityWarning}
                    />
                    {this.props.subtitle && <VisualSubtitle text={this.props.subtitle} />}
                </div>
            </div>
        );
    }
}
